module.exports = "pegasus_template/assets/themelp1/app/101.png";